module.exports = __webpack_public_path__ + "img/image3.7188b3d3.png";